import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabaseClient';

/**
 * Hook: imoveis de uma area via junction area_imoveis, com proprietarios.
 *
 * Modulo Imoveis Fase B — 1 area : N imoveis : M proprietarios.
 * Retorna a lista de area_imoveis (cada item tem .imovel aninhado).
 */
export const useImoveisArea = (areaId) => {
  const [imoveis, setImoveis] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAll = useCallback(async () => {
    if (!areaId) { setImoveis([]); return; }
    setLoading(true);
    setError(null);
    try {
      const { data, error: qErr } = await supabase
        .from('area_imoveis')
        .select(`
          id, ordem, notas,
          imovel:imoveis(
            id, nome, area_terreno_m2, area_construida_m2, situacao, matricula,
            endereco, numero, bairro, tipo_uso_atual, valor_venal,
            lote:lotes(id, nome, zoneamento, area_total_m2),
            proprietarios:imovel_proprietarios(
              id, percentual_participacao, tipo_propriedade,
              empresa:empresas!imovel_proprietarios_proprietario_empresa_id_fkey(id, empresa, company_name),
              contato:contatos!imovel_proprietarios_proprietario_contato_id_fkey(id, first_name, last_name)
            )
          )
        `)
        .eq('area_id', areaId)
        .order('ordem', { ascending: true });

      if (qErr) throw qErr;
      setImoveis(data || []);
    } catch (err) {
      console.error('[useImoveisArea] fetch falhou:', err);
      setError(err.message);
      setImoveis([]);
    } finally {
      setLoading(false);
    }
  }, [areaId]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  return { imoveis, loading, error, refetch: fetchAll };
};
